import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router/immutable'
import { PersistGate } from 'redux-persist/es/integration/react'
import * as Sentry from '@sentry/browser'
import 'moment/locale/ru'
import 'moment/locale/zh-cn'
import 'moment/locale/fr'
import 'moment/locale/es'
import ReactModal from 'react-modal'

import App from 'app/domains'
import 'app/assets/styles/index.scss'
import 'app/config/configure.moment'
import 'react-dates/initialize'
import GlobalLoaderOrSpinner from 'app/components/Loaders/GlobalLoaderOrSpinner'
import Error from 'app/components/ComponentError'

class Root extends Component {
  static propTypes = {
    store: PropTypes.object,
  }

  state = {
    error: null,
  }

  unsubscribe

  componentDidMount() {
    this.unsubscribe = this.props.store.subscribe(this.checkNewError)

    // Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
    const elementExists = document.getElementById('docroot')
    if (elementExists) {
      ReactModal.setAppElement('#docroot')
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    Sentry.withScope(scope => {
      scope.setExtra('errorInfo', errorInfo)
      scope.setExtra('where error was happen', 'componentDidCatch')
      Sentry.captureException(error)
    })
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  checkNewError = () => {
    const error = this.props.store
      .getState()
      .get('analytics')
      .get('error')
    if (error && this.state.error !== error) {
      this.setState({ error })
    }
  }

  render() {
    if (this.state.error) {
      console.log('__ERROR___', this.state.error)
      return <Error />
    }
    const { store, history, persistor } = this.props
    return (
      <Provider store={store}>
        <PersistGate loading={<GlobalLoaderOrSpinner />} onBeforeLift={() => {}} persistor={persistor}>
          <ConnectedRouter history={history}>
            <div className="root__router-wrapper">
              <App />
            </div>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    )
  }
}

export default Root
